export default () => ({
  id: null,
  category_id: null,
  locations: [],
  regions: [],
  opportunities: [],
  assigned_admin: [],
  requested_department: [],
  client: [],
  pipeline_status: [],
  date_from: null,
  date_to: null,
  amount_low: null,
  amount_high: null,
  keywords: null,
  management: null,
  talent: [],
  sort: 'date',
  order: 'asc'
})
